export default "__VITE_ASSET__CxuIEnxo__"